import { DataEntryVehicleStepSectionProps, typedMemo } from "src/types";
import {
  FormRow,
  InputDate,
  InputGroup,
  InputSelect,
  InputText,
} from "src/ui/widgets";
import { useDataEntryVehicleStepDriver } from "./vehicle-step-driver.hook";
import { InputPhone } from "src/ui/widgets/input-phone/input-phone";

export const DataEntryVehicleStepDriver = typedMemo(
  (props: DataEntryVehicleStepSectionProps) => {
    const {
      formikFieldBaseName,
      formikVehicleValues,
      formikVehicleErrors,
      formikVehicleTouched,
      formik,
      validationSchema,
    } = props;
    const {
      yesNoOptions,
      disableDriverFieldIfDriverCoincidesWithContractor,
      licenseTypes,
      t,
    } = useDataEntryVehicleStepDriver(props);

    const { handleChange, handleBlur, setFieldTouched, setFieldValue } = formik;

    return (
      <>
        <FormRow
          firstField={
            <InputGroup
              style="radio"
              name={`${formikFieldBaseName}.driver.driverCoincidesWithContractor`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              options={yesNoOptions}
              validationSchema={validationSchema}
              touched={
                formikVehicleTouched?.driver?.driverCoincidesWithContractor
              }
              value={formikVehicleValues.driver.driverCoincidesWithContractor}
              error={formikVehicleErrors?.driver?.driverCoincidesWithContractor}
              label={t(
                "data_entry.vehicle_step.section_driver_dirver_contractor_question"
              )}
              classes="m-0 ps-0"
              classesLabel="m-0 p-0 d-flex align-items-center mb-3"
            />
          }
        />
        <FormRow
          firstField={
            <InputText
              disabled={disableDriverFieldIfDriverCoincidesWithContractor}
              name={`${formikFieldBaseName}.driver.name`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.driver?.name}
              value={formikVehicleValues.driver.name}
              error={formikVehicleErrors?.driver?.name}
              label={`${t("commons.name")}`}
              placeholder={t("commons.insert")}
            />
          }
          secondField={
            <InputText
              disabled={disableDriverFieldIfDriverCoincidesWithContractor}
              name={`${formikFieldBaseName}.driver.surname`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.driver?.surname}
              value={formikVehicleValues.driver.surname}
              error={formikVehicleErrors?.driver?.surname}
              label={`${t("commons.surname")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
        <FormRow
          firstField={
            <InputDate
              name={`${formikFieldBaseName}.driver.dateOfBirth`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.driver?.dateOfBirth}
              value={formikVehicleValues.driver.dateOfBirth}
              error={formikVehicleErrors?.driver?.dateOfBirth}
              label={`${t("commons.birth_date")}`}
              placeholder={t("commons.insert")}
              disabledTo={undefined}
              classes="m-0 p-0"
            />
          }
          secondField={
            <InputText
              disabled={disableDriverFieldIfDriverCoincidesWithContractor}
              name={`${formikFieldBaseName}.driver.fiscalCodeOrVAT`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.driver?.fiscalCodeOrVAT}
              value={formikVehicleValues.driver.fiscalCodeOrVAT}
              error={formikVehicleErrors?.driver?.fiscalCodeOrVAT}
              label={`${t("commons.fiscal_code_vat_num")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
        <FormRow
          firstField={
            <InputText
              disabled={disableDriverFieldIfDriverCoincidesWithContractor}
              name={`${formikFieldBaseName}.driver.address`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.driver?.address}
              value={formikVehicleValues.driver.address}
              error={formikVehicleErrors?.driver?.address}
              label={`${t("commons.address_and_details")}`}
              placeholder={t("commons.insert")}
            />
          }
          secondField={
            <InputPhone
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              name={`${formikFieldBaseName}.driver.phoneNumber`}
              touched={formikVehicleTouched?.driver?.phoneNumber}
              value={formikVehicleValues.driver.phoneNumber}
              error={formikVehicleErrors?.driver?.phoneNumber}
              label={`${t("commons.phone_number")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
        <FormRow
          firstField={
            <InputText
              name={`${formikFieldBaseName}.driver.email`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.driver?.email}
              value={formikVehicleValues.driver.email}
              error={formikVehicleErrors?.driver?.email}
              label={`${t("commons.email_address")}`}
              placeholder={t("commons.insert")}
            />
          }
          secondField={
            <InputText
              name={`${formikFieldBaseName}.driver.licenseNumber`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.driver?.licenseNumber}
              value={formikVehicleValues.driver.licenseNumber}
              error={formikVehicleErrors?.driver?.licenseNumber}
              label={`${t("commons.license_number")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
        <FormRow
          firstField={
            <InputSelect
              name={`${formikFieldBaseName}.driver.category`}
              validationSchema={validationSchema}
              setFieldValue={setFieldValue}
              handleChange={handleChange}
              options={licenseTypes}
              touched={formikVehicleTouched?.driver?.category}
              value={formikVehicleValues.driver.category?.value}
              error={formikVehicleErrors?.driver?.category}
              label={`${t("commons.category")}`}
              placeholder={t("commons.insert")}
            />
          }
          secondField={
            <InputDate
              name={`${formikFieldBaseName}.driver.validUntil`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.driver?.validUntil}
              value={formikVehicleValues.driver.validUntil}
              error={formikVehicleErrors?.driver?.validUntil}
              label={`${t("commons.valid")} ${t("commons.until")} ${t("commons.to")}`}
              placeholder={t("commons.insert")}
              disabledTo={undefined}
              classes="m-0 p-0"
            />
          }
        />
      </>
    );
  }
);
